import { ArrowLeft, SearchX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import Logo from '@/components/common/Logo';
import { Button, Card } from '@/components/ui';
import { useAppSelector } from '@/store';
import { homeRouteFor, ROUTES } from '@/utils/constants';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const user = useAppSelector((state) => state.auth.user);

  return (
    <div className="min-h-screen bg-cream">
      <header className="sticky top-0 z-10 border-b border-line bg-white shadow-sm">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Logo />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              void navigate(-1);
            }}
            className="flex items-center gap-1.5"
          >
            <ArrowLeft size={16} />
            Back
          </Button>
        </div>
      </header>

      <main className="mx-auto flex max-w-7xl flex-col items-center justify-center px-4 py-12 text-center sm:px-6 sm:py-24 lg:px-8">
        <Card padding="lg" className="flex flex-col items-center gap-4">
          <span className="grid h-16 w-16 place-items-center rounded-full bg-cream">
            <SearchX className="h-8 w-8 text-ink/40" />
          </span>
          <p className="text-xs font-semibold uppercase tracking-wider text-ink/40">404</p>
          <h1 className="text-2xl font-semibold text-ink">Page not found</h1>
          <p className="max-w-sm text-ink/60">
            The page you&apos;re looking for doesn&apos;t exist, or may have been moved.
          </p>
          <Button
            onClick={() => {
              void navigate(isAuthenticated ? homeRouteFor(user) : ROUTES.LANDING);
            }}
            className="mt-2"
          >
            {isAuthenticated ? 'Go to my workspace' : 'Go home'}
          </Button>
        </Card>
      </main>
    </div>
  );
};

export default NotFoundPage;
